/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PlaidConnectionRead } from '../models/PlaidConnectionRead';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class PlaidService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Create Plaid Link Token
     * @param entityId
     * @returns any Successful Response
     * @throws ApiError
     */
    public createPlaidLinkToken(
        entityId: string,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/integrations/plaid/create-link-token',
            path: {
                'entity_id': entityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Plaid Link Token For Update
     * @param entityId
     * @param connectionId
     * @returns any Successful Response
     * @throws ApiError
     */
    public createPlaidLinkTokenForUpdate(
        entityId: string,
        connectionId: string,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/integrations/plaid/create-link-token-for-update',
            path: {
                'entity_id': entityId,
            },
            query: {
                'connection_id': connectionId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Plaid Connection
     * @param entityId
     * @param publicToken
     * @param requestBody
     * @returns PlaidConnectionRead Successful Response
     * @throws ApiError
     */
    public createPlaidConnection(
        entityId: string,
        publicToken: string,
        requestBody: Record<string, any>,
    ): CancelablePromise<PlaidConnectionRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/integrations/plaid/create-connection',
            path: {
                'entity_id': entityId,
            },
            query: {
                'public_token': publicToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Reconnect Plaid Connection
     * @param entityId
     * @param connectionId
     * @param publicToken
     * @returns void
     * @throws ApiError
     */
    public reconnectPlaidConnection(
        entityId: string,
        connectionId: string,
        publicToken: string,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/integrations/plaid/update-connection/{connection_id}',
            path: {
                'entity_id': entityId,
                'connection_id': connectionId,
            },
            query: {
                'public_token': publicToken,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Disconnect Plaid Connection
     * @param entityId
     * @param connectionId
     * @param archive
     * @param assetAccountId
     * @returns void
     * @throws ApiError
     */
    public disconnectPlaidConnection(
        entityId: string,
        connectionId: string,
        archive?: (boolean | null),
        assetAccountId?: (string | null),
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/integrations/plaid/disconnect-connection/{connection_id}',
            path: {
                'entity_id': entityId,
                'connection_id': connectionId,
            },
            query: {
                'archive': archive,
                'asset_account_id': assetAccountId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
